import script from "./promptCategoryList.vue?vue&type=script&lang=ts&setup=true"
export * from "./promptCategoryList.vue?vue&type=script&lang=ts&setup=true"

import "./promptCategoryList.vue?vue&type=style&index=0&id=65b6f6e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65b6f6e2"]])

export default __exports__